import {
  businessCheckingProductRedirect,
  kabbageProductRedirect,
  personalSavingsLegacyProductRedirect,
  sixtyDaysPastDueProductRedirect,
  nonCardLendingProductRedirect,
  aamRedirect,
  composeRedirector,
} from '@americanexpress/rerouter';
import { PERSONAL_CHECKING_ACCOUNT, PERSONAL_SAVINGS_ACCOUNT } from '@americanexpress/product-ducks';
import noMycaProductRedirect from '../redirectors/noMycaProductRedirect';
import mycaUnsupportedMarketProductRedirect from '../redirectors/mycaUnsupportedMarketProductRedirect';
import statementsRedirect from '../utils/statementsRedirect';

const dataRedirector = composeRedirector([
  mycaUnsupportedMarketProductRedirect,
  businessCheckingProductRedirect,
  kabbageProductRedirect,
  personalSavingsLegacyProductRedirect,
  sixtyDaysPastDueProductRedirect,
  nonCardLendingProductRedirect,
  noMycaProductRedirect,
  aamRedirect,
  statementsRedirect,
]);

const dataRouter = ({
  locale,
  state,
  route,
  productsOrder,
  productsRegistry,
  opaqueAccountId,
  registry,
  details,
}) => {
  const {
    selectedProduct,
    CARD_PRODUCT,
    [PERSONAL_CHECKING_ACCOUNT]: CONSUMER_CHECKING_ACCOUNT,
    [PERSONAL_SAVINGS_ACCOUNT]: CONSUMER_SAVING_ACCOUNT,
  } = productsRegistry;

  return dataRedirector({
    locale,
    state,
    route,
    CARD_PRODUCT,
    CONSUMER_CHECKING_ACCOUNT,
    CONSUMER_SAVING_ACCOUNT,
    productsOrder,
    selectedProduct,
    opaqueAccountId,
    registry,
    details,
    preferOverview: true,
  });
};

export default dataRouter;
